import { z } from "zod";

// Base schema for a successful response
export const BaseSuccessSchema = z.object({
  isSuccess: z.literal(true).describe("Operation success flag"),
  data: z.unknown().describe("Response payload"),
});

export type BaseSuccessType = z.infer<typeof BaseSuccessSchema>;

// Utility to wrap a schema in the success response envelope
export const wrapSuccessResponse = <T extends z.ZodTypeAny>(dataSchema: T) => {
  return BaseSuccessSchema.extend({
    data: dataSchema,
  });
};

// Base schema for an error response
export const BaseErrorSchema = z.object({
  isSuccess: z.literal(false).describe("Operation error flag"),
  error: z.object({
    status: z.number().nonnegative().describe("Error code"),
    code: z.string().nonempty().describe("Error code"),
    message: z.string().nonempty().describe("Error message"),
  }),
});

export type BaseErrorType = z.infer<typeof BaseErrorSchema>;
